import { render, staticRenderFns } from "./FootersPanel.vue?vue&type=template&id=6318a3a7&scoped=true&"
import script from "./FootersPanel.vue?vue&type=script&lang=js&"
export * from "./FootersPanel.vue?vue&type=script&lang=js&"
import style0 from "./FootersPanel.vue?vue&type=style&index=0&id=6318a3a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6318a3a7",
  null
  
)

export default component.exports